import { initializeForm } from '../../utils/form';
import { amountToInteger, makeAmountInput } from '../../utils/form_utils';
import {
  validateNotEmpty,
  validateMakeAnOffer,
  validateMaxLength,
} from '../../utils/validators';
import { MAKE_AN_OFFER_EVENTS } from '../../event_bus_modules/make_an_offer';

const $auctionMakeAnOfferModal = $('#auction-make-an-offer-modal');
const isUserAuthenticated = $('#_is-user-authenticated').val() === 'True';
const auctionDetails = $('#auction-details');
const $loaderLayer = $auctionMakeAnOfferModal.find('.loader-layer');
const auctionMakeAnOfferFormWrapper = $auctionMakeAnOfferModal.find(
  '.auction-make-an-offer-modal__form-wrapper'
);

const auctionMakeAnOfferSuccessMessage = $auctionMakeAnOfferModal.find(
  '.auction-make-an-offer-modal__success-message'
);
const auctionMakeAnOfferErrorMessage = $auctionMakeAnOfferModal.find(
  '.auction-make-an-offer-modal__error-message'
);
const auctionMakeAnOfferForm = $('#auction-make-an-offer-form');
const csrfToken = auctionMakeAnOfferForm
  .find('input[name="csrfmiddlewaretoken"]')
  .val();

const entityId = $('#_entity-id').val();
const currency = $('input#_currency').val();

$(() => {
  const auctionMakeAnOfferFormInstance = initializeForm(
    auctionMakeAnOfferForm,
    {
      preventDefault: true,
      validate: (values) => {
        const errors = {
          ...validateMakeAnOffer(values),
          ...validateMaxLength(values, 'comment', {}, 500),
          ...validateNotEmpty(values, ['offer_amount']),
        };

        const hasErrors = !$.isEmptyObject(errors);
        auctionMakeAnOfferForm
          .find('button[type="submit"]')
          .attr('disabled', hasErrors);

        return errors;
      },

      onSubmit: (values) => {
        const offerAmountInt = amountToInteger(values.offer_amount);
        const propertyUrl = window.location.href;
        EVENT_BUS.dispatch(MAKE_AN_OFFER_EVENTS.AUCTION_MAKE_AN_OFFER_REQUEST, {
          entityId,
          values: {
            ...values,
            offer_amount: offerAmountInt,
            property_url: propertyUrl,
          },
          csrfToken,
        });
      },
    }
  );

  const inputElement = $('input[name="offer_amount"]').get()[0];
  makeAmountInput(inputElement, currency);

  const showLoaderLayer = () => {
    $loaderLayer.addClass('loader-layer--active');
  };

  if (isUserAuthenticated) {
    if (document.cookie.includes('action=buy_now')) {
      if (auctionDetails.length>0) {
        window.scrollTo({
          top: auctionDetails.offset().top,
          behavior: 'smooth',
        });
      }
      $auctionMakeAnOfferModal.modal('show');
      document.cookie = 'action=; path=/; Max-Age=-99999999;';
    }
  }

  const hideLoaderLayer = () => {
    $loaderLayer.removeClass('loader-layer--active');
  };

  const resetForm = () => {
    auctionMakeAnOfferForm
      .find("textarea, input:not([name='submit'], [type='hidden'])")
      .val('')
      .trigger('change');
    auctionMakeAnOfferFormInstance.restart();
  };

  const onSuccessfulAuctionMakeAnOffer = () => {
    hideLoaderLayer();
    auctionMakeAnOfferFormWrapper.hide();
    auctionMakeAnOfferSuccessMessage.show();
    auctionMakeAnOfferErrorMessage.hide();
    resetForm();
  };

  const onAuctionMakeAnOfferError = () => {
    hideLoaderLayer();
    auctionMakeAnOfferErrorMessage.show();
  };

  const resetModalState = () => {
    auctionMakeAnOfferFormWrapper.show();
    auctionMakeAnOfferSuccessMessage.hide();
    auctionMakeAnOfferErrorMessage.hide();
    resetForm();
  };

  EVENT_BUS.on(
    MAKE_AN_OFFER_EVENTS.AUCTION_MAKE_AN_OFFER_REQUEST,
    showLoaderLayer
  );
  EVENT_BUS.on(
    MAKE_AN_OFFER_EVENTS.AUCTION_MAKE_AN_OFFER_REQUEST_SUCCESS,
    onSuccessfulAuctionMakeAnOffer
  );
  EVENT_BUS.on(
    MAKE_AN_OFFER_EVENTS.AUCTION_MAKE_AN_OFFER_REQUEST_ERROR,
    onAuctionMakeAnOfferError
  );

  $auctionMakeAnOfferModal.on('hide.bs.modal', resetModalState);
});
